import React, { useEffect, useState } from "react";
import ErrorFallback from "./ErrorFallback";

const SmartRoute = ({ element: Component, disableFallback = false }) => {
  const [hasContent, setHasContent] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      const main = document.querySelector("main");
      if (main && main.innerText.trim().length === 0) {
        setHasContent(false);
      }
    }, 400);

    return () => clearTimeout(timer);
  }, []);

  // If content is missing and fallback not disabled → show message
  if (!hasContent && !disableFallback) {
    return <ErrorFallback />;
  }

  // ✅ FIX: render the component as <Component />
  return <Component />;
};

export default SmartRoute;
